<template>
  <div
    class="tooltip"
    role="tooltip"
  >
    <slot />
    <div
      class="tooltip-arrow"
      data-popper-arrow
    />
  </div>
</template>

<script>
// import { createPopper } from '@popperjs/core'
import { createPopper } from '@popperjs/core/lib/popper-lite.js'

export default {
  name: 'VueTooltip',
  props: {
    // css selector
    selector: {
      type: String,
      default: ''
    },
    // popperjs 参数, 参考文档 https://popper.js.org/docs/v2/constructors/
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      popperInstance: null
    }
  },
  mounted() {
    if (this.selector) {
      setTimeout(() => {
        const target = document.querySelector(this.selector)
        const { offset = [0, 0], ...resetOptions } = this.options
        this.popperInstance = createPopper(target, this.$el, {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset
              }
            }
          ],
          ...resetOptions
        })
        this.$el.setAttribute('data-show', '')
      }, 300)
    }
  }
}
</script>

<style>
.tooltip {
  display: none;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #333;
  color: white;
  font-size: 13px;
}

.tooltip[data-show] {
  display: block;
}

/*
.tooltip-arrow,
.tooltip-arrow::before {
  position: absolute;
  width: 8px;
  height: 8px;
  z-index: -1;
}

.tooltip-arrow::before {
  content: '';
  transform: rotate(45deg);
  background: #333;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: -4px;
} */
</style>
